import { NavLink } from 'react-router-dom';
import { signOut } from 'firebase/auth';
import { auth } from '../config/firebase';

const navItems = [
  { path: '/', label: 'Panel', icon: '📊' },
  { path: '/companies', label: 'Tiendas', icon: '🏬' },
  { path: '/users', label: 'Usuarios', icon: '👥' },
  { path: '/admins', label: 'Super admins', icon: '🛡️' },
  { path: '/settings', label: 'Configuración', icon: '⚙️' },
];

function Sidebar({ user }) {
  const handleLogout = async () => {
    try {
      await signOut(auth);
    } catch (error) {
      console.error("Logout error", error);
    }
  };

  return (
    <aside className="sidebar">
      <div className="sidebar-header">
        <div className="sidebar-brand">
          <img src="/Estoquia.jpg" alt="" className="sidebar-logo" />
          <span>Esto<span className="text-secondary">quia</span></span>
        </div>
        <p className="sidebar-tagline">Super admin</p>
      </div>

      <nav className="sidebar-nav">
        {navItems.map((item) => (
          <NavLink
            key={item.path}
            to={item.path}
            end={item.path === '/'}
            className={({ isActive }) => `sidebar-link ${isActive ? 'active' : ''}`}
          >
            <span className="sidebar-link-icon" aria-hidden="true">{item.icon}</span>
            <span>{item.label}</span>
          </NavLink>
        ))}
      </nav>

      <div className="sidebar-footer">
        <div className="sidebar-user">
          <div className="sidebar-avatar">
            {user?.email?.charAt(0).toUpperCase() || 'A'}
          </div>
          <div className="sidebar-user-info">
            <p className="sidebar-user-email" title={user?.email}>{user?.email}</p>
            <p className="sidebar-user-role">Super administrador</p>
          </div>
        </div>
        <button onClick={handleLogout} className="sidebar-logout">
          Cerrar sesión
        </button>
      </div>
    </aside>
  );
}

export default Sidebar;
